import * as React from 'react';
import { memo } from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSubdivisions = function SvgSubdivisions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v128c-35.299 0-64-28.701-64-64s28.591-64 64-64Z",
    fill: "#E6F0F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 55.875a3.052 3.052 0 0 0 3.042-3.063A3.052 3.052 0 0 0 79.5 49.75a3.052 3.052 0 0 0-3.042 3.063 3.052 3.052 0 0 0 3.042 3.062Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.813 52.546C60.813 44.508 66.903 34 79.5 34c12.598 0 18.687 10.508 18.687 18.546 0 2.134-1.036 5.1-2.51 8.237-1.162 2.475-2.639 5.141-4.218 7.73l4.109 1.345 29.273-10.433a.862.862 0 0 1 .791.11c.231.164.368.43.368.715v45.816a.874.874 0 0 1-.566.82l-29.552 11.059a.867.867 0 0 1-.584.008l-31.865-10.958-29.261 10.95a.863.863 0 0 1-.799-.102.875.875 0 0 1-.373-.718V70.782c0-.37.232-.7.58-.824l29.185-10.403c-1.17-2.675-1.952-5.156-1.952-7.01ZM79.5 35.75c-11.402 0-16.949 9.468-16.949 16.796 0 1.707.873 4.359 2.343 7.489 1.45 3.088 3.418 6.51 5.472 9.706 2.055 3.196 4.182 6.144 5.945 8.284.884 1.073 1.661 1.925 2.282 2.5.311.29.564.492.756.615.067.044.117.07.151.088a1.55 1.55 0 0 0 .15-.088 5.84 5.84 0 0 0 .757-.614c.62-.576 1.398-1.428 2.282-2.5 1.763-2.141 3.89-5.09 5.945-8.285 2.054-3.196 4.022-6.618 5.472-9.706 1.47-3.13 2.343-5.782 2.343-7.49 0-7.327-5.547-16.795-16.949-16.795Zm10.593 34.942.415-.65 4.202 1.376V115.9L64.29 105.44V62.748c1.342 2.617 2.957 5.361 4.617 7.944 2.082 3.239 4.25 6.245 6.066 8.45.906 1.1 1.74 2.019 2.441 2.67.35.325.686.601.998.802.279.18.666.386 1.088.386.421 0 .81-.206 1.088-.386.312-.2.648-.477.998-.802.701-.651 1.535-1.57 2.44-2.67 1.817-2.205 3.985-5.211 6.067-8.45Zm-27.542 34.766v-43.97l-27.813 9.913v44.465l27.813-10.408ZM96.45 71.401v44.465l27.813-10.408v-43.97l-27.813 9.913Z",
    fill: "#231F20"
  })));
};

var Memo = /*#__PURE__*/memo(SvgSubdivisions);

export { Memo as default };
//# sourceMappingURL=subdivisions.svg.js.map
